import { render, staticRenderFns } from "./Images.vue?vue&type=template&id=604493d8"
import script from "./Images.vue?vue&type=script&lang=js"
export * from "./Images.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports